import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cvariable(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>C Variable tutorial For Beginners</title>
 <meta name="description" content="C variable tutorial for beginners.Variable is the name of a memory location in which we can store the value and use string, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,static variable in c,tutorial for begineers,learn code in free,learn code in free online,c variable types,string in c,string c tutorial,string variables in c,c variables,c variable arguments,c variable size array,c global variable across files,c variable declaration rules,c variable cannot start with,c extern variable example" />
 <link rel="canonical" href="https://www.codeexampler.com/c-variable" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C Variable Tutorial</h1>
    <div className="first">
      
        <a href="/c-scope-of-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">
    1, Variable is the name of a memory location in which we can store the value <br/>
2, C Variable can change the value<br/>
3,  A variable is defined by combining an identifier, data types, and an initializer.<br/>
4, The first character in the variable name must be an alphabet, underscore, a digit, or 
a dollar sign. <br/>
5, All variables have a scope<br/>
6, The identifier is the name of the Variable<br/>
7, Commas or blanks not used inside a Variable Name

    </p>
    <h2 className="mt-4 mh2">Variable syntax in C:</h2>



<h2 className='headings'>C Variable Declaration Syntax</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-3"> type</span>
                <span className="qwerty-10"> variable-name</span>
                <span className="qwerty-4">;</span>
                {"\n"}{"\n"}
                <span className="qwerty-3">  int </span>
                <span className="qwerty-8">is a type</span>
            {"\n"}{"\n"}
                <span className="qwerty-10">  a</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-8"> and</span>
                <span className="qwerty-10"> ab </span>
                <span className="qwerty-8"> are a variable name</span>
            {"\n"}   {"\n"}
                 </code>
        </pre>
        </div> 




<h2 className='headings'>C Variable Declaration Syntax Examples:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-3"> type</span>
                <span className="qwerty-10"> variable-name</span>
                <span className="qwerty-4">;</span>
                {"\n"}{"\n"}
                <span className="qwerty-3"> int</span>
                <span className="qwerty-10"> roll_no</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //this declare a variable</span>
                {"\n"}{"\n"}                
                <span className="qwerty-3"> float</span>
                <span className="qwerty-10"> percentage</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //this declare a variable</span>
                {"\n"}{"\n"}             
                <span className="qwerty-10"> roll_no</span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-1">40</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //assigns a variable a value </span>
                            {"\n"}   {"\n"}                            
                <span className="qwerty-10"> percentage</span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-1">40.80</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //assigns a variable a value </span>
                            {"\n"}   {"\n"}
                 </code>
        </pre>
        </div> 


<h2 className="mt-4 mh2">Declare a Variable in C Rules:</h2>
<p className="mt-4 para">Variable declare in various types. </p>




       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-3"> int</span>
                <span className="qwerty-10"> abc</span>
                <span className="qwerty-5"> //this declare a variable</span>
                <span className="qwerty-4">;</span>
                {"\n"}{"\n"}
                <span className="qwerty-3"> int</span>
                <span className="qwerty-10"> abc</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //(abc and a_bc) are a variable</span>
                {"\n"}{"\n"}                
                <span className="qwerty-3"> int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-10">x</span>
                <span className="qwerty-4">,</span>
                <span className="qwerty-10">z</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //(a,b,x,z)are a variable</span>
                {"\n"}{"\n"}             
                <span className="qwerty-3"> byte</span>
                <span className="qwerty-10"> a1</span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-1">40</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //initialize a </span>
                            {"\n"}   {"\n"}  
                <span className="qwerty-3"> double</span>                          
                <span className="qwerty-10"> a2</span>
                <span className="qwerty-4">=</span>
                <span className="qwerty-1">40.80</span>
                <span className="qwerty-4">;</span>
                <span className="qwerty-5"> //like a float </span>
                            {"\n"}   {"\n"}                              
                <span className="qwerty-3"> char</span>                          
                <span className="qwerty-10"> a3</span>
                <span className="qwerty-4">="</span>
                <span className="qwerty-1">ram</span>
                <span className="qwerty-4">"";</span>
                <span className="qwerty-5"> //a variable gain value </span>                  
                <span className="qwerty-1">(ram)</span>     
                {"\n"}  {"\n"}                     
                 </code>
        </pre>
        </div> 


<h2 className="mt-4 mh2">Addition of variables Examples:</h2>

<h2 className='headings'>Q-Write a program to add variables in C?</h2>
      <div style={{background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px" }}>
        <pre style={{ maxHeight:"100vh"}}>
          <code >{"\n"}
              <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
                        {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>            
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>            
            {"\n"}{"\n"}
                <span className="qwerty-5">     int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10"> b</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10"> c</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10"> d</span>
                <span className="qwerty-3">;</span>              
              {"\n"}{"\n"}
                    <span className="qwerty-10">     a</span>
                    <span className="qwerty-3">=</span>
                    <span className="qwerty-10">10</span>
                    <span className="qwerty-3">;</span>
                    
                    <span className="qwerty-10"> b</span>
                    <span className="qwerty-3">=</span>
                    <span className="qwerty-10">20</span>
                    <span className="qwerty-3">;</span>
                    
                    <span className="qwerty-10"> c</span>
                    <span className="qwerty-3">=</span>
                    <span className="qwerty-10">30</span>
                    <span className="qwerty-3">;</span>

                    <span className="qwerty-10"> d</span>
                    <span className="qwerty-3">=</span>
                    <span className="qwerty-10">40</span>
                    <span className="qwerty-3">;</span>            
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">("</span>
                <span className="qwerty-10">a+b+c+d</span>
                <span className="qwerty-3">");</span>
            {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}          
                <span className="qwerty-3">&#125;</span>
                {"\n"}{"\n"}
        </code>
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >     {"\n"}             
                  <span className="qwerty-10">100</span>     
                  {"\n"}{"\n"}              
                </code>
                </pre>
                </div> 


<h2 className="mt-4 mh2">Variable increment values in C:
</h2>


<h2 className='headings'>Q-Write a program variable Increment in C?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123;</span>
            {"\n"}{"\n"}
                <span className="qwerty-5">   int</span>
                <span className="qwerty-10"> a </span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-10"> 10</span>
                <span className="qwerty-3">;</span>
                <span className="qwerty-2"> // a is a variable and a is a variable</span>
            {"\n"}{"\n"}
                    <span className="qwerty-10">   a</span>
                    <span className="qwerty-11"> + </span>
                    <span className="qwerty-3">=</span>
                    <span className="qwerty-10"> 40</span>
                    <span className="qwerty-3">;</span>
            {"\n"}{"\n"} 
                    <span className="qwerty-10">   a </span>
                    <span className="qwerty-3">=</span>
                    <span className="qwerty-6"> a </span>
                    <span className="qwerty-11">+ </span>
                    <span className="qwerty-10">20</span>
                    <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-7">   printf</span>
                <span className="qwerty-8"> (</span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-8">) </span>
                <span className="qwerty-3">;</span>        
                    {"\n"}{"\n"}
                <span className="qwerty-10">   return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}
                <span className="qwerty-4" >&#125;</span>
                {"\n"}{"\n"}
        </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">70</span>
                        {"\n"}{"\n"}
              </code>
                </pre>
                </div>




<h2 className='headings'>Q-Write a program to create a variable, store a no inside this Variable and print output in C?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
                      {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
                        {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
                        {"\n"}{"\n"}
                <span className="qwerty-5">     int</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">;</span>
                        {"\n"}{"\n"}
              <span className="qwerty-10">     a</span>
              <span className="qwerty-3">=</span>
              <span className="qwerty-10">40</span>
              <span className="qwerty-3">;</span>
              {"\n"}{"\n"}
                          <span className="qwerty-8">OR</span>
            {"\n"}{"\n"} 
              <span className="qwerty-5">     int</span> 
              <span className="qwerty-10"> a</span>
              <span className="qwerty-3">=</span>
              <span className="qwerty-10">40</span>
              <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
              <span className="qwerty-7">     printf</span>
              <span className="qwerty-3">(</span>
              <span className="qwerty-10">a</span>
              <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}
                <span className="qwerty-3" >&#125;</span>
                {"\n"}{"\n"}
        </code>
        </pre>
        </div>          
        <h2 className='headings'> Output :</h2>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >                    
                    {"\n"}
                        <span className="qwerty-10">40</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
                </div>

<h2 className="mt-4 mh2">String in C</h2>
<p className="mt-4 para">1, String is a sequence of characters and closed in " ".<br/>
2, String is the name of a memory location in which we can store the Text<br/>
3, Text of String change  easily<br/>
4, Text or character enclosed by double quotes<br/>
</p>

<h2 className="mt-4 mh2">Create Variable String Type: </h2>




<h2 className='headings'>Q-Write a program to create a string variable and store a no inside string type variable and print output in C?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     string</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-10">Ram</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>            
            {"\n"}{"\n"}
                <span className="qwerty-5">     string</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-10">Lakshman</span>
                <span className="qwerty-2">"</span>
                <span className="qwerty-3">;</span>  
                {"\n"}{"\n"}
                <span className="qwerty-8">OR</span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     string</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">;</span>  
            {"\n"}{"\n"}
                    <span className="qwerty-10">     a</span>
                    <span className="qwerty-3">=</span>
                    <span className="qwerty-3">"</span>
                    <span className="qwerty-10">Ram</span>
                    <span className="qwerty-3">"</span>
                    <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-10">     b</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-10">Lakshman</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>            
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">(</span>
                <span className="qwerty-10">a+b</span>
                <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}
                <span className="qwerty-4" >&#125;</span>
                {"\n"}{"\n"}
        </code>
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
          <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">RamLakshman</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
                <div>
                    </div>   </div>

<h2 className="mt-4 mh2"> Another string type static variable in c example</h2>



<h2 className='headings'>Q-Write a program to create a string variable and store a no inside string type Static variable and print output in C?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-3">&#60;</span>
                <span className="qwerty-5">stdio.h</span>
                <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">int </span>
                <span className="qwerty-10">main</span>
                <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
                <span className="qwerty-3" > &#123; </span>
            {"\n"}{"\n"}
                <span className="qwerty-5">     string</span>
                <span className="qwerty-10"> a</span>
                <span className="qwerty-3">,</span>
                <span className="qwerty-10">b</span> 
                <span className="qwerty-3">,</span>  
                <span className="qwerty-10">c</span> 
                <span className="qwerty-3">;</span>  
          {"\n"}{"\n"}                
                <span className="qwerty">     a</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-10">Ram</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>         
            {"\n"}{"\n"}                
                <span className="qwerty">     b</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-10">Lakshman</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}                
                <span className="qwerty">     c</span>
                <span className="qwerty-3">=</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-10">My Name is CodeExampler 160208</span>
                <span className="qwerty-3">"</span>
                <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
                <span className="qwerty-7">     printf</span>
                <span className="qwerty-3">(</span>
                <span className="qwerty-10">a</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-3">" "</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-10">b</span>
                <span className="qwerty-11">+</span>
                <span className="qwerty-3">" "</span>
                <span className="qwerty-11">+</span>                
                <span className="qwerty-10">c</span>
                <span className="qwerty-3">" "</span>
                <span className="qwerty-3">);</span>
                       {"\n"}{"\n"}
                <span className="qwerty-10">     return</span>
                <span className="qwerty-4"> 0</span>
                <span className="qwerty-3">; </span>
            {"\n"}
                <span className="qwerty-4" >&#125;</span>
                {"\n"}{"\n"}
        </code>
        </pre>
        </div>          
        <h4 className='headings'>Output :</h4>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"50vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">Ram Lakshman My name is CodeExampler 160208</span>
                        {"\n"}{"\n"}
                </code>
                </pre>
        </div>

<h2 className="mt-4 mh2">Constant:</h2>

<p className="mt-4 para">Constant is use when you store a value inside a variable,
 but after you can't overwrite existing value, so on that place use constantly.
</p>
<h1 className="mt-5">  </h1>
<div className="back">
      
        <a href="/c-scope-of-variable">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cvariable;